import { render, staticRenderFns } from "./Prize_info_modal.vue?vue&type=template&id=6f364b9b"
import script from "./Prize_info_modal.vue?vue&type=script&lang=js"
export * from "./Prize_info_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports